import { Component, Vue } from 'vue-property-decorator';
import { isEmpty, isString } from 'lodash';

interface StyleParam {
  backgroundColor?: string;
  borderColor?: string;
}

@Component
export default class colorSectionMenuMixin extends Vue {
  get menuSectionColor(): string {
    if (this.$store) {
      const { regionProfile } = this.$store.state;
      return !isEmpty(regionProfile) && isString(regionProfile.colorMenuSection)
        ? `#${regionProfile.colorMenuSection}`
        : '#7665cd';
    }
    return '#7665cd';
  }

  get sectionMenuStyle(): StyleParam {
    const { menuSectionColor } = this;
    return !!menuSectionColor.length
      ? {
          backgroundColor: `${menuSectionColor}`,
          borderColor: `${menuSectionColor}`,
        }
      : {};
  }
}



// WEBPACK FOOTER //
// ./src/mixins/colorSectionMenu.ts